function initProductSwatches() {
    const activeLink = document.querySelector('.color-swatch-link.is-active');
    const colorItemCode = document.querySelector('.color-item-code');
    const detailColorItem = document.querySelector('.detail-color-item');

    if (activeLink && colorItemCode) {
        const activeColor = activeLink.dataset.color;
        colorItemCode.textContent = activeColor;
        colorItemCode.dataset.selectedValue = activeColor;
        if(detailColorItem){
            detailColorItem.textContent = activeColor;
        }
    }

    const swatchLinks = document.querySelectorAll('.color-swatch-link');

    swatchLinks.forEach(link => {
        link.addEventListener('mouseenter', () => {
            if (colorItemCode) {
                colorItemCode.textContent = link.dataset.color;
            }
        });

        link.addEventListener('mouseleave', () => {
            if (colorItemCode) {
                colorItemCode.textContent = colorItemCode.dataset.selectedValue;
            }
        });
    });
}

document.addEventListener('DOMContentLoaded', initProductSwatches);
document.addEventListener('swup:page:view', initProductSwatches);
